<template>
    <div class="w-full md:max-w-(--breakpoint-md) md:mx-auto mb-6 px-2">
        <div class="bg-white border border-gray-200 rounded-lg p-6 shadow-xs">
            <div class="flex items-start gap-4">
                <div class="shrink-0">
                    <div class="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                        <i class="bi bi-archive text-purple-600 text-xl" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="grow">
                    <h3 class="title-body-bold text-gray-900 mb-2">Welcome back!</h3>
                    <p class="text-gray-700 mb-6">
                        I recommend starting a fresh session for the best coaching experience. Don't worry—I'll remember everything from our previous conversations.
                    </p>
                    <div class="flex flex-col sm:flex-row gap-3 justify-center">
                        <BaseLink :href="$startChatUrl" :data="{ chat_source: CHATSOURCE.RETURN_TO_CHAT }">
                            <BaseButton theme="primary" class="flex items-center gap-2" @click="handleStartNewSession">
                                <i class="bi bi-plus-circle" aria-hidden="true"></i>
                                Start New Session
                            </BaseButton>
                        </BaseLink>
                        <BaseButton theme="tertiary" class="flex items-center gap-2" @click="handleContinueChat">
                            <i class="bi bi-chat-dots" aria-hidden="true"></i>
                            Continue Chat
                        </BaseButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import BaseButton from "~vue/components/BaseButton.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { CHATSOURCE } from "~vue/utils/constants";
import { logUserInteraction } from "~vue/utils/logUtils";
import { inject, onMounted } from "vue";

const emit = defineEmits(["continue-chat"]);

const coachingSessionUuid = inject("coachingSessionUuid");

// Track when the return-to-chat dialog is shown
onMounted(() => {
    logUserInteraction("return_to_chat_dialog_shown", { coaching_session_id: coachingSessionUuid });
});

const handleStartNewSession = () => {
    logUserInteraction("return_to_chat_start_new_session_clicked", { coaching_session_id: coachingSessionUuid });
};

const handleContinueChat = () => {
    logUserInteraction("return_to_chat_continue_chat_clicked", { coaching_session_id: coachingSessionUuid });
    emit("continue-chat");
};
</script>
